export const POLICY_TAGS = {
    POLICY: "POLICY",
} as const;